module.exports = __webpack_public_path__ + "img/registration-07.e78507e9.png";